"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _themeProvider = _interopRequireDefault(require("@influitive/secret-garden/lib/theme-provider"));

var _profileCard = require("../actions/profile-card");

var _profileCard2 = _interopRequireDefault(require("../components/profile-card"));

var _fromHub = require("../from-hub");

var _colorsUtil = require("../colors-util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var themeOverrides = {};

if (_fromHub.hubPrimaryColor) {
  themeOverrides['colors'] = {
    primary: (0, _colorsUtil.themePrimaryColors)(_fromHub.hubPrimaryColor)
  };
}

if (_fromHub.hubCustomFont.enabled && _fromHub.hubCustomFont.url) {
  themeOverrides['fonts'] = {
    family: [_fromHub.hubCustomFont.name]
  };
}

var ProfileCard =
/*#__PURE__*/
function (_Component) {
  _inherits(ProfileCard, _Component);

  function ProfileCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProfileCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProfileCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.props.hideProfile(_this.props.profileCardId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleHideProfile", function () {
      var _this$props = _this.props,
          hideProfile = _this$props.hideProfile,
          profileCardId = _this$props.profileCardId;
      hideProfile(profileCardId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggleProfile", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          profileCardId = _this$props2.profileCardId,
          toggleProfile = _this$props2.toggleProfile;
      toggleProfile(id, profileCardId);
    });

    return _this;
  }

  _createClass(ProfileCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.initializeProfileCard(this.props.profileCardId);
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.anonymous) {
        return _react.default.createElement(_themeProvider.default, {
          theme: themeOverrides
        }, this.props.children);
      }

      var _this$props3 = this.props,
          disableMessage = _this$props3.disableMessage,
          disableViewProfile = _this$props3.disableViewProfile,
          position = _this$props3.position,
          profileCardId = _this$props3.profileCardId,
          profileDetails = _this$props3.profileDetails;
      return _react.default.createElement(_themeProvider.default, {
        theme: themeOverrides
      }, _react.default.createElement(_profileCard2.default, {
        "data-fs": this.props['data-fs'],
        "data-qa": this.props['data-qa'],
        disableMessage: disableMessage,
        disableViewProfile: disableViewProfile,
        hideProfile: this.handleHideProfile,
        position: position,
        profileDetails: profileDetails[profileCardId],
        toggleProfile: this.handleToggleProfile
      }, this.props.children));
    }
  }]);

  return ProfileCard;
}(_react.Component);

_defineProperty(ProfileCard, "propsTypes", {
  profileCardId: _propTypes.default.string.isRequired,
  profileDetails: _propTypes.default.object.isRequired,
  theme: _propTypes.default.object.isRequired,
  disableViewProfile: _propTypes.default.bool.isRequired,
  disableMessage: _propTypes.default.bool.isRequired,
  anonymous: _propTypes.default.bool
});

_defineProperty(ProfileCard, "defaultProps", {
  anonymous: false
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    profileDetails: state
  };
}, {
  initializeProfileCard: _profileCard.initializeProfileCard,
  hideProfile: _profileCard.hideProfile,
  toggleProfile: _profileCard.toggleProfile
})(ProfileCard);

exports.default = _default;